import React from "react";
import { formatPhone } from "../../utils/formatPhone";

const ContactDropdown = ({
    isContactOpen,
    toggleContactMenu,
    freelancerData,
    isMobile,
    handleSendContactForm,
}) => {
    return (
        <div className="contact-button-container">
            <button
                className="contact-button"
                onClick={toggleContactMenu}
            >
                <i className="fa-solid fa-envelope" />
                <span>Contact</span>
                <i className="fa-solid fa-chevron-down caret" />
            </button>

            {isContactOpen && (
                <div className="contact-dropdown">
                    <div className="contact-info">
                        <p>
                            <i className="fa-solid fa-phone" />
                            <span>
                                Phone:{" "}
                                {freelancerData?.phone_number
                                    ? formatPhone(
                                        freelancerData.phone_number
                                    )
                                    : "Not Available"}
                            </span>
                        </p>

                        <p>
                            <i className="fa-solid fa-envelope" />
                            <span>
                                Email:{" "}
                                {freelancerData?.contact_email ||
                                    "Not Available"}
                            </span>
                        </p>
                    </div>

                    {isMobile && (
                        <div className="freelancer-links-row">
                            {freelancerData?.portfolio_link && (
                                <a
                                    href={freelancerData.portfolio_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="freelancer-portfolio-icon"
                                    title="Website"
                                >
                                    <i className="fa-solid fa-link"></i>
                                </a>
                            )}

                            {freelancerData?.facebook && (
                                <a
                                    href={freelancerData.facebook}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="freelancer-portfolio-icon"
                                    title="Facebook"
                                >
                                    <i className="fa-brands fa-facebook"></i>
                                </a>
                            )}

                            {freelancerData?.instagram && (
                                <a
                                    href={freelancerData.instagram}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="freelancer-portfolio-icon"
                                    title="Instagram"
                                >
                                    <i className="fa-brands fa-instagram"></i>
                                </a>
                            )}

                            {freelancerData?.x && (
                                <a
                                    href={freelancerData.x}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="freelancer-portfolio-icon"
                                    title="X"
                                >
                                    <i className="fa-brands fa-x-twitter"></i>
                                </a>
                            )}

                            {freelancerData?.youtube && (
                                <a
                                    href={freelancerData.youtube}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="freelancer-portfolio-icon"
                                    title="YouTube"
                                >
                                    <i className="fa-brands fa-youtube"></i>
                                </a>
                            )}
                        </div>
                    )}

                    <div className="contact-divider" />

                    <button
                        className="contact-form-button"
                        onClick={handleSendContactForm}
                    >
                        <i className="fa-solid fa-paper-plane" />
                        {" "}Send a Contact Form
                    </button>
                </div>
            )}
        </div>
    );
};

export default ContactDropdown;